import React, {Component} from 'react'
import PropTypes from 'prop-types'

class TableRow extends Component {
    render() {
        const {item} = this.props
        const {products, labelDetails, trackingUrl} = item
        const shippedAt = item.packaged_at ? new Date(item.packaged_at).toLocaleString('en-GB') : ''
        const {
            'partnerTrackingNumber': orderTrackingNumber,
            'url': orderTrackingUrl
        } = Object.assign({}, {'partnerTrackingNumber': ''}, labelDetails)
        const types = products.map(item => {
            return item.type
        })
        const uniqueSet = new Set(types)
        const typeArr = [...uniqueSet]

        return (
            <tr className="TableRow">
                <td>{item.packageName || item.orderNumber}</td>
                <td>
                    {
                        orderTrackingNumber &&
                        <React.Fragment>
                            <a href={orderTrackingUrl} target='_blank' rel="noopener noreferrer" className='mr-1'>
                                {orderTrackingNumber}
                            </a>
                            <a href={trackingUrl}
                               target='_blank' rel="noopener noreferrer">
                                <i className='icon-new-tab mr-1' title='Xem Label Tracking'/>
                            </a>
                        </React.Fragment>
                    }
                </td>
                <td><span className="text-primary">#{item.barcodeNumber || ''}</span></td>
                <td>{shippedAt || ''}</td>
                <td>{item.name || ''}</td>
                <td>{item.address1 || ''}</td>
                <td>{item.address2 || ''}</td>
                <td>{item.city || ''}</td>
                <td>{item.postalCode || ''}</td>
                <td>{item.state || ''}</td>
                <td>{item.country || ''}</td>
                <td>{typeArr.join(' + ')}</td>
                <td>{item.weight || ''}</td>
                <td>{item.ioss}</td>
                <td>{item.box_id}</td>
                <td>{item.source}</td>
            </tr>
        )
    }
}

TableRow.propTypes = {
    item: PropTypes.object
}

export default TableRow
